export const taxSystemMoral = [
  'General de Ley Personas Morales',
  'Personas Morales con Fines no Lucrativos',
  'Residentes en el Extranjero sin Establecimiento Permanente en México',
  'Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
  'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
  'Opcional para Grupos de Sociedades',
  'Coordinados',
];
